import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'phoneFormat'
})
export class PhoneFormatPipe implements PipeTransform {
    transform(value: string): string {
        if (!value) return value;

        let v = value.replace(/[^\d]/g, '');

        if (v.length > 10) {
            return '+' + v;
        }

        if (v.length === 10) {
            return '(' + v.substr(0, 3) + ') ' + v.substr(3, 3) + '-' + v.substr(6, 4);
        }

        if (v.length === 7) {
            return v.substr(0, 3) + '-' + v.substr(3, 4);
        }

        return value;
    }
}
